<template>

<app-content :loading="is.loading && !is.initialised">

	<app-content-head title="Payments" subtitle="View your payment history.">

		<app-content-head-actions-item text="Update" icon="card" v-on:click="onUpdateClick" />

	</app-content-head>

	<app-content-body :loading="is.loading && is.initialised" :is-empty="!collection.length" placeholder="Sorry, no payments found.">

		<app-table>

			<app-table-head :layout="layout">

				<app-table-column text="Status" />
				<app-table-column text="Date" />
				<app-table-column text="Type" />
				<app-table-column text="Plan" />
				<app-table-column text="Method" />
				<app-table-column text="Amount" />

			</app-table-head>

			<app-table-body>

				<app-table-row v-on:click="onEditClick(item.id)" :danger="item.status === 1" :warning="item.status === $constants.registration.sale.status.partial" :layout="layout" v-for="item in collection" :key="item.id">

					<app-table-cell-label :text="$constants.membership.subscription.billing.statusName[item.status]" :type="$constants.membership.subscription.billing.statusColour[item.status]"  />
					<app-table-cell-text :text="item.date.start | localDate('MM/DD/YYYY')" />
					<app-table-cell-text :text="item.type.name" />
					<app-table-cell-text :text="item.plan.name" />
					<app-table-cell-text :text="$constants.membership.subscription.billing.typeName[item.method]" />
					<app-table-cell-text :text="item.amount | formatMoney" />

				</app-table-row>

			</app-table-body>

		</app-table>

	</app-content-body>

</app-content>

</template>

<script>

import mixCollection from '@/mixin/collection'

export default {

	mixins: [mixCollection],

	data: function() {

		return {
			pagination: false,
			layout: '80px auto 160px 160px 80px 80px 24px',
			endpoint: 'membership/payments'
		}

	},

	methods: {

        onUpdateClick: function() {
		
			this.$router.push({
				name: 'Membership.Payments.Update'
			})
		
		}
	
	}

}

</script>

<style scoped>

</style>